import React from 'react';
import Seo from '../../components/Seo';
import LegalPageLayout from './LegalPageLayout';

export default function TermsConditions() {
  return (
    <LegalPageLayout title="Terms & Conditions" lastUpdated="10 June 2026">
      <Seo
        title="Terms & Conditions"
        description="The terms and conditions that apply when you enrol on an Atlas Academy distance learning course."
        path="/terms"
      />
      <div>
        <h2>1. About these terms</h2>
        <p>
          These terms apply when you use this website or enrol on a course with Atlas Academy. By submitting
          an application or making a payment, you agree to these terms. If you have any questions, contact us
          at <a href="mailto:info@atlas-academy.co.uk">info@atlas-academy.co.uk</a> before enrolling.
        </p>
      </div>
      <div>
        <h2>2. Courses and enrolment</h2>
        <ul>
          <li>Course descriptions, durations, and entry requirements are set out on each course page.</li>
          <li>Enrolment is confirmed once we have received your application and your first payment, and we have sent you confirmation by email.</li>
          <li>Qualifications are awarded by the relevant awarding body (such as OTHM or QUALIFI), subject to you meeting their assessment requirements. Atlas Academy delivers tuition and support; certificates are issued by the awarding body.</li>
        </ul>
      </div>
      <div>
        <h2>3. Fees and payment plans</h2>
        <ul>
          <li>Course fees are shown on each course page. All payments are processed securely by Stripe.</li>
          <li>Where a payment plan (instalment) option is offered, the instalment schedule and total payable — including any payment-plan fee — are shown before you pay.</li>
          <li>You remain responsible for completing all instalments. Certificates and final results may be withheld until all fees are paid in full.</li>
        </ul>
      </div>
      <div>
        <h2>4. Cancellations and refunds</h2>
        <ul>
          <li>You have a 14-day cooling-off period from the date of enrolment, in line with the Consumer Contracts Regulations 2013. If you cancel within 14 days and have not accessed course materials, you will receive a full refund.</li>
          <li>If you have accessed course materials within the cooling-off period, we may deduct a reasonable amount for the service provided before cancellation.</li>
          <li>After the 14-day period, fees are non-refundable except where required by law. To cancel, email <a href="mailto:info@atlas-academy.co.uk">info@atlas-academy.co.uk</a>.</li>
        </ul>
      </div>
      <div>
        <h2>5. Your responsibilities</h2>
        <ul>
          <li>Provide accurate information when applying and keep your contact details up to date.</li>
          <li>All submitted work must be your own. Plagiarism or malpractice may result in withdrawal without refund, in line with awarding body policies.</li>
          <li>Course materials are for your personal study only and may not be copied, shared, or resold.</li>
        </ul>
      </div>
      <div>
        <h2>6. Our responsibilities</h2>
        <p>
          We will provide the course materials, tutor support, and assessment services described on the
          course page with reasonable care and skill. We may occasionally update course content to keep it
          current or to meet awarding body requirements.
        </p>
      </div>
      <div>
        <h2>7. Liability</h2>
        <p>
          Nothing in these terms excludes liability that cannot be excluded by law. We are not liable for
          events outside our reasonable control, or for indirect losses such as loss of earnings. Our total
          liability in connection with a course is limited to the fees you have paid for that course.
        </p>
      </div>
      <div>
        <h2>8. General</h2>
        <p>
          These terms are governed by the law of England and Wales, and the courts of England and Wales have
          jurisdiction. If any part of these terms is found unenforceable, the rest remains in effect. We may
          update these terms from time to time; the version in force when you enrol applies to your enrolment.
        </p>
      </div>
    </LegalPageLayout>
  );
}
